export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'customJobPositions' as const;

export const RELATIONSHIP_TYPES = {
  JOB: 'job',
} as const;

export const POSITION_TYPES = {
  CUSTOM: 'custom',
} as const;
